module.exports = __webpack_public_path__ + "static/media/Roswell_banner.4eafa227.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/Roswell_banner.png
// module id = 502
// module chunks = 0